import Vue from "vue"
import "./plugins/vuetify"
import App from "./App.vue"
import router from "./router/"
import store from "./store"
import "./registerServiceWorker"
import "roboto-fontface/css/roboto/roboto-fontface.css"
import "font-awesome/css/font-awesome.css"
import "material-icons/iconfont/material-icons.css"
import axios from "axios"
import VueAxios from "vue-axios"
import Vuetify from "vuetify"
import colors from "vuetify/es5/util/colors"
import VCharts from "v-charts"
import "line-awesome/css/line-awesome.css"
import VueExcelXlsx from "vue-excel-xlsx"
import Notifications from "vue-notification"
import AOS from "aos"
import "aos/dist/aos.css"
import VueHtmlToPaper from "vue-html-to-paper"
import "./styles.css"

// Translation provided by Vuetify (javascript)
import es from "vuetify/es5/locale/es"

Vue.use(VueAxios, axios)
Vue.use(Vuetify, {
    lang: {
        locales: { es },
        current: "es"
    },
    theme: {
        primary: colors["green"].base
    }
})
Vue.use(VCharts)
Vue.use(VueExcelXlsx)
Vue.use(Notifications)

const options = {
    name: "_blank",
    specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"]
}
Vue.use(VueHtmlToPaper, options)

Vue.config.productionTip = false

new Vue({
    created() {
        AOS.init()
    },
    router,
    store,
    render: h => h(App)
}).$mount("#app")
